import { render, staticRenderFns } from "./royaltyList.vue?vue&type=template&id=7b904df9"
import script from "./royaltyList.vue?vue&type=script&lang=js"
export * from "./royaltyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports